import {
    Avatar,
    Button,
    ChevronStartIcon,
    CloseIcon,
    Flex,
    Text,
} from "@fluentui/react-northstar";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { _api_get_recap_annual_recap } from "../../api";
import { AVATAR_DEFAULT } from "../../../../constants";
import CardRecapYear from "../CardRecapYear/CardRecapYear";
import { DialogStyle } from "../../../../pages/DashboardTasks/style";

const DialogRecapOfAnnualRecap = ({
    user_id = 1,
    user_avatar = AVATAR_DEFAULT,
    user_name = "Yanis la rénak",
    year = new Date().getFullYear(),
}) => {
    const [open, setOpen] = useState(false);

    const { data: recap, isLoading } = useQuery(
        ["recapOfAnnualRecap", { year, id_user: user_id }],
        (data) => {
            const { year, id_user } = data.queryKey[1];
            return _api_get_recap_annual_recap({
                year,
                id_user,
            });
        },
        {
            enabled: open === true,
            refetchOnWindowFocus: false,
        }
    );

    const closeDialog = () => {
        return setOpen(false);
    };

    return (
        <DialogStyle
            header={{
                content: (
                    <Flex vAlign="center" gap="gap.small">
                        <Button
                            size="small"
                            iconOnly
                            flat
                            icon={<ChevronStartIcon />}
                            onClick={closeDialog}
                        />
                        <Text content="Récapitulatif de la récupération annuelle" />
                    </Flex>
                ),
            }}
            headerAction={{
                icon: <CloseIcon />,
                onClick: closeDialog,
            }}
            content={
                <Flex column gap="gap.medium">
                    <Flex gap="gap.small" vAlign="center">
                        <Avatar image={user_avatar} name={user_name} />
                        <Text
                            content={user_name}
                            size="large"
                            weight="regular"
                        />
                    </Flex>
                    <Flex column gap="gap.small">
                        <Flex>
                            <Text content={`Année ${year}`} />
                        </Flex>
                        <Flex
                            gap="gap.medium"
                            wrap
                            styles={{
                                rowGap: "8px",
                                maxHeight: "480px",
                                overflowY: "auto",
                                paddingBottom: "8px",
                            }}
                        >
                            {isLoading ? (
                                <Text content="Chargement..." />
                            ) : (
                                recap?.map((card) => {
                                    return (
                                        <CardRecapYear
                                            key={card.id}
                                            title={card.title}
                                            description={card.description}
                                            added_value={card.added_value}
                                            value_after={card.value_after}
                                            is_from_timesheet={
                                                card.is_from_timesheet
                                            }
                                        />
                                    );
                                })
                            )}
                            {recap?.length === 0 && (
                                <Flex hAlign="center" fill>
                                    <Text
                                        temporary
                                        content="Aucune donnée à afficher"
                                    />
                                </Flex>
                            )}
                        </Flex>
                    </Flex>
                </Flex>
            }
            trigger={
                <Text
                    content="Récapitulatif de la récupération annuelle >"
                    onClick={() => {
                        return setOpen(true);
                    }}
                    styles={{
                        cursor: "pointer",
                        color: "var(--color-link)",
                        ":hover": { textDecoration: "underline" },
                    }}
                />
            }
            open={open}
            onCancel={closeDialog}
        />
    );
};

export default DialogRecapOfAnnualRecap;
